import { render, staticRenderFns } from "./MajorInterstitial.vue?vue&type=template&id=40bce778&scoped=true&"
import script from "./MajorInterstitial.vue?vue&type=script&lang=js&"
export * from "./MajorInterstitial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bce778",
  null
  
)

export default component.exports